@if (isVisible) {
  <div class="consent-banner" role="dialog" aria-live="polite" aria-label="{{ 'consent.title' | translate }}">
    <div class="consent-banner__content">
      <p class="consent-banner__text">
        {{ 'consent.description' | translate }}
        <a class="consent-banner__link" routerLink="/politica-privacidade">
          {{ 'consent.policy-link' | translate }}
        </a>
      </p>
    </div>
    <div class="consent-banner__actions">
      <button class="consent-banner__btn consent-banner__btn--reject" type="button" (click)="reject()">
        {{ 'consent.reject' | translate }}
      </button>
      <button class="consent-banner__btn consent-banner__btn--accept" type="button" (click)="accept()">
        {{ 'consent.accept' | translate }}
      </button>
    </div>
  </div>
}
